var COJ = COJ || {};

COJ.RelatedColors = function() {

    var _store = {};

    var _fetchRelatedProductsRemotely = function(productReferenceTag, collectionHandle) {
        let data;

        const query = `
            {
                collectionByHandle(handle: "${collectionHandle}") {
                    products(first: 10, filters: [{tag: "${productReferenceTag}"}]) {
                        edges {
                            node {
                                handle
                                colorGroup: metafield(namespace: "channelengine", key: "ColorGroupEN") {
                                    value
                                }
                            }
                        }
                    }
                }
            }
        `;

        $.ajax({
            url: 'https://coj-denim.myshopify.com/api/2024-07/graphql,json',
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": "38731196c5f027579b3fcce3c4b4d05a",
            },
            data: JSON.stringify({ query: query })
        })
        .done(function(response) {
            // cache related products data in store
            _store[_productReferenceTagToReference(productReferenceTag)] = response;
            // update product cards
            _updateProductCards(productReferenceTag);
        });

    }

    var _fetchRelatedProducts = function(productCard) {
        // retrieve collection handle + product reference
        let productReferenceTag = productCard.data('prod-ref');

        // convert product reference tag to product reference
        let productReference = _productReferenceTagToReference(productReferenceTag);

        // if product reference does not exist in store, fetch data and update cards
        if (!_store.hasOwnProperty(productReference)) {
            let collectionHandle = productCard.data('collection');
            _fetchRelatedProductsRemotely(productReferenceTag, collectionHandle);
        } else {
            _updateProductCards(productReferenceTag);
        }
    }

    var _productReferenceTagToReference = function(productReferenceTag) {
        return productReferenceTag.replace(/reference-/g,'');
    }

    var _slugify = function(str) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
        str = str.toLowerCase(); // convert string to lowercase
        str = str.replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
                    .replace(/\s+/g, '-') // replace spaces with hyphens
                    .replace(/-+/g, '-'); // remove consecutive hyphens
        return str;
    }

    var _updateProductCards = function(productReferenceTag) {
        let relatedProductData = _store[_productReferenceTagToReference(productReferenceTag)];
        let relatedProducts = relatedProductData.data.collectionByHandle.products.edges;
        // console.log(relatedProducts);
        $('.product--teaser[data-rel-color-fetched="no"][data-prod-ref="' + productReferenceTag + '"]').each(function() {
            let productCard = $(this);

            productCard.data('rel-color-fetched', 'yes');
            productCard.attr('data-rel-color-fetched', 'yes');

            let productColorsWrapper = productCard.find('.product__colors');
            let productCardUrl = productColorsWrapper.find('.color-badge--active').attr('href');

            for (let index = 0; index < relatedProducts.length; index++) {
                let relProduct = relatedProducts[index];
                if (productCardUrl !== '/products/' + relProduct.node.handle) {
                    let colorSlug = _slugify(relProduct.node.colorGroup.value);
                    let colorBadge = `
                        <a
                            class="color-badge color-badge--${colorSlug}"
                            href="/products/${relProduct.node.handle}"
                            title="${relProduct.node.colorGroup.value}">
                            <span></span>
                        </a>
                    `;
                    productColorsWrapper.append(colorBadge);
                }
            }
        });
    }

    var _init = function() {
        // loop all unprocessed product cards
        $('.product--teaser[data-rel-color-fetched="no"]').each(function() {
            // fetch the related products for a given product card
            _fetchRelatedProducts($(this));
        });
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    // COJ.RelatedColors.init();
});
